import { PROVIDE_CLIENT_INTAKE_FORM_CONTEXT_STATE } from '@db-access/clientIntakeFormContext';
import { provideStates } from '@ngxs/store';
import { IntakeFormContextState } from './state/intake-form-context.state';

export const PROVIDE_INTAKE_FORM_CONTEXT_STATE = [
	provideStates([IntakeFormContextState]),
	...PROVIDE_CLIENT_INTAKE_FORM_CONTEXT_STATE,
];
